/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Saverolechanges2Inputs */

const en_settings_collaborators_saverolechanges2 = /** @type {(inputs: Settings_Collaborators_Saverolechanges2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save role changes?`)
};

/**
* | output |
* | --- |
* | "Save role changes?" |
*
* @param {Settings_Collaborators_Saverolechanges2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_saverolechanges2 = /** @type {((inputs?: Settings_Collaborators_Saverolechanges2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Saverolechanges2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_saverolechanges2(inputs)
});
export { settings_collaborators_saverolechanges2 as "settings_collaborators_saveRoleChanges" }